import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title", "aria-label"]
const _hoisted_2 = { class: "visually-hidden" }

import {useUrlStore} from "@/store/SerpPage/UrlStore";
import {useSearchQueryStore} from "@/store/SearchQueryStore";
import {useMobileViewStore} from "@/store/MobileViewStore";
import {useBridgeStore} from "@/store/BridgeStore";
import { computed, inject, ref, toRefs, unref } from "vue";
import {storeToRefs} from "pinia";
import type {
  CustomSmartSearchLabels,
  SmartSearchConfigInterface,
  SmartSearchTranslationsInterface
} from "@/core/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClearQueryButton',
  props: {
    autocomplete: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const urlStore = useUrlStore();
const queryStore = useSearchQueryStore();
const {hasQuery} = toRefs(queryStore);

const bridgeStore = useBridgeStore();
const mobileViewStore = useMobileViewStore();
const {isMobileView} = storeToRefs(mobileViewStore);

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchConfig = ref(inject<SmartSearchConfigInterface>("SmartSearchConfig")!);
const SmartSearchTranslations = inject('SmartSearchTranslations') as any;
const {showButtonOnInput} = SmartSearchConfig.value.serp;
const {redirectionUrl} = SmartSearchConfig.value.appConfiguration;
const customLabels = (typeof window !== 'undefined'
  ? (window as any)?._QONizer?.customSmartSearchConfig?.labels
  : undefined) as CustomSmartSearchLabels | undefined;

const normalizeLabel = (label: unknown): string | undefined => {
  if (typeof label !== 'string') {
    return undefined;
  }

  const trimmed = label.trim();
  return trimmed ? trimmed : undefined;
};

const clearLabel = computed(() => {
  const customLabel = props.autocomplete
    ? normalizeLabel(customLabels?.autocomplete?.clearQuery)
    : normalizeLabel(customLabels?.serp?.clearQuery);

  if (customLabel) {
    return customLabel;
  }

  const translationCandidates = [
    normalizeLabel(unref(SmartSearchTranslations)?.autocomplete?.clearQuery),
    normalizeLabel(unref(SmartSearchTranslations)?.userRecentQueries?.clearButton),
    normalizeLabel(unref(SmartSearchTranslations)?.filters?.clear)
  ];

  const resolvedTranslation = translationCandidates.find(Boolean);
  if (resolvedTranslation) {
    return resolvedTranslation as string;
  }

  return 'Wyczyść';
});

const focusSearchInput = () => {
  const inputElement = document.getElementById('autocomplete-search__input') as HTMLInputElement | null;

  if (props.autocomplete) {
    if (isMobileView.value) {
      bridgeStore.focusInternalInput();
    } else {
      bridgeStore.focusClientInput();
    }
  } else if (!inputElement) {
    bridgeStore.focusClientInput();
  }

  if (inputElement) {
    window.requestAnimationFrame(() => {
      inputElement.focus();
      if (inputElement.value) {
        inputElement.select();
      }
    });
  }
};

const handleClear = async () => {
  await urlStore.clearQuery(redirectionUrl, Boolean(props.autocomplete));
  focusSearchInput();
};

return (_ctx: any,_cache: any) => {
  return (_unref(hasQuery))
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        id: "autocomplete-search__clear-button",
        class: _normalizeClass(["autocomplete-search__clear-button", { 'q-input-with-button': _unref(showButtonOnInput) }]),
        type: "button",
        title: clearLabel.value,
        "aria-label": clearLabel.value,
        onClick: _withModifiers(handleClear, ["prevent"])
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("svg", {
          class: "q-icon q-icon--gmail-x",
          viewBox: "0 0 24 24",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          _createElementVNode("path", {
            d: "M6 6l12 12M18 6L6 18",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.25",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1)),
        _createElementVNode("span", _hoisted_2, _toDisplayString(clearLabel.value), 1)
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})